import { createListenerMiddleware, isAnyOf } from "@reduxjs/toolkit";
import { updateTableRecordStage } from "@redux/patientTableRecordsSlice";
import {
    endReview,
    markReviewEntered,
    markSkipped,
    ReviewSessionState,
    setCurrentIndex,
    startReview,
} from "./reviewSessionSlice";
import { saveReviewSession } from "./reviewSessionStorage";

/** EN-18: writes the review to this tab's storage after every change a refresh must keep, and clears it on end. */
export const reviewSessionPersistenceMiddleware = createListenerMiddleware();

reviewSessionPersistenceMiddleware.startListening({
    matcher: isAnyOf(startReview, markReviewEntered, setCurrentIndex, markSkipped, endReview, updateTableRecordStage),
    effect: (_action, api) => {
        saveReviewSession((api.getState() as { reviewSession: ReviewSessionState }).reviewSession);
    },
});
